import React from 'react';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideTrainingExecute: React.FC = () => {
  return (
    <GuidePageLayout
      title="コードを実行して履歴を確認する"
      description="実行可能なファイル（.java 等）のコードを実行し、実行結果と履歴を確認・リバートします。"
      breadcrumbs={[
        { label: 'ワークスペース（コードエディタ）概要', path: '/guide/training/overview' },
      ]}
    >
      <GuideSection title="コードを実行する">
        <GuideStepList
          steps={[
            { label: '実行可能な拡張子のファイル（例: .java）を開く' },
            {
              label: '右下の「実行」ボタンを押す',
              content: (
                <GuideMockContainer label="実行ボタン">
                  <GuideMockButton label="実行" color="success" startIcon={<PlayArrowIcon />} />
                </GuideMockContainer>
              ),
            },
            { label: '内容が自動保存された後、コードが実行される' },
            { label: '実行結果がモーダルで表示される（ステータス・標準出力・実行時間等）' },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>
            実行ボタンは実行可能な拡張子（言語IDを持つ拡張子）のファイルの場合のみ表示されます。md
            等では表示されません。
          </GuideInfoBox>
          <GuideInfoBox type="warning">
            実行に時間がかかるコードは「実行時間超過」というステータスで結果が返ることがあります（これも履歴に保存されます）。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="実行履歴を確認する">
        <GuideStepList
          steps={[
            { label: '実行可能な拡張子のファイルを開く' },
            { label: 'アクティビティバーで「実行履歴」を選択する' },
            { label: '開いているファイルの実行履歴が新しい順に一覧表示される' },
            { label: '履歴の1件をクリックすると実行結果の詳細がモーダルで表示される' },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>
            実行不可の拡張子（md
            等）を開いている時や未オープン時は「表示できる実行履歴がありません」と表示されます。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="履歴の操作">
        <GuideTable
          headers={['操作', '内容']}
          rows={[
            [
              'リバート（↩）',
              '確認ダイアログのうえ、その実行時点の内容にファイルを戻します（現在の編集内容は失われます）。',
            ],
            ['削除（ゴミ箱）', '確認ダイアログのうえ、実行履歴を1件削除します（取り消し不可）。'],
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox type="warning">
            リバート時も、他ユーザーが先にファイルを更新していた場合は「最新を取得」の案内が表示されます。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideTrainingExecute;
